import { useState, useCallback } from 'react';
import { useTableData } from '../../../components/dataTable/hooks/useTableData';
import { useNotifications } from '../../../hooks/useNotifications';
import { AdminService } from '../../../services/adminService';

export const useUserSessions = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { setTableData, ...tableData } = useTableData();
  const { showErrorNotification, showSuccessNotification } = useNotifications();

  const getData = useCallback(
    async ({ page }) => {
      setIsLoading(true);
      try {
        const { sessions, pageSize, total } = await AdminService.getSessions({ idUser: userId, page });
        setTableData({
          data: sessions,
          total,
          page,
          pageSize,
        });
      } catch (error) {
        showErrorNotification({
          title: 'error',
          description: 'errorRetrievingRecords',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [userId, setTableData, showErrorNotification],
  );

  const reloadData = () => {
    getData({ page: tableData.page });
  };

  const revokeSession = useCallback(
    async (sessionId) => {
      setIsLoading(true);
      try {
        await AdminService.revokeSession(sessionId);
        showSuccessNotification({
          title: 'success',
          description: 'successRevokingSession',
        });
        await getData({ page: tableData.page });
      } catch (error) {
        showErrorNotification({
          title: 'error',
          description: 'errorRevokingSession',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [getData, tableData.page, showSuccessNotification, showErrorNotification],
  );

  return {
    isLoading,
    reloadData,
    tableData,
    getData,
    revokeSession,
  };
};
